import 'jquery-validation';

let $ = jQuery;

if (window.language === 'pl') {
  $.extend($.validator.messages, {
    required: "To pole jest wymagane.",
    email: "Proszę o podanie prawidłowego adresu email."
  });
}

class NewsletterMailerLite {
  constructor($form) {
    this.form = $form;
    this.inputEmail = this.form.find('.newsletter-freshmail-email');
    this.buttonSend = this.form.find('.btn-long-arrow--send');
    this.buttonSending = this.form.find('.btn-long-arrow--sending');
    this.listId = this.form.find('input[name="list"]').val(); // Pobranie ID listy

    // Sprawdzenie, czy formularz jest w popupie
    this.isPopup = this.form.closest('.modal').length > 0;

    // Znalezienie modali do komunikatów (jeśli to popup)
    this.successModal = document.getElementById('newsletterModal-success');
    this.errorModal = document.getElementById('newsletterModal-error');
    this.errorModal1304 = document.getElementById('newsletterModal-error-1304');

    this.successMessage = this.form.find('.newsletter-popup__after-send--success');
    this.errorMessage = this.form.find('.newsletter-popup__after-send--error');
    this.errorMessage1304 = this.form.find('.newsletter-popup__after-send--error-1304');

    this.bind();
  }

  send() {
    return new Promise((resolve, reject) => {
      console.log("📡 Wysyłanie danych do API...");




      let formData = new FormData(this.form[0]);
      formData.append("list", this.listId); // Upewnienie się, że list ID jest dodany


              
        console.log("📩 [JS] Email przed wysłaniem:", formData.get("email"));
        console.log("📋 [JS] List ID przed wysłaniem:", formData.get("list"));


      jQuery.ajax({
        method: 'POST',
        url: settings.ajaxurl,
        data: new URLSearchParams(formData).toString(),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        success: (response) => {
          console.log("✅ Odpowiedź serwera:", response);

          this.hideAllMessages();

          if (this.isPopup) {
            // Obsługa dla popupa
            this.form.find('.newsletter-popup__before-send').addClass('d-none');
            this.form.find('.newsletter-popup__privacy-policy').addClass('d-none');
            this.form.find('.newsletter-popup__submit').addClass('d-none');

            if (response && response.success) {
              this.successMessage.removeClass('d-none');
            } else if (response.data && response.data.message.includes("już istnieje")) {
              this.errorMessage1304.removeClass('d-none');
            } else {
              this.errorMessage.removeClass('d-none');
            }
          } else {
            // Obsługa dla statycznego formularza
            if (response && response.success) {
              this.showModal(this.successModal);
            } else if (response.data && response.data.message.includes("już istnieje")) {
              this.showModal(this.errorModal1304);
            } else {
              this.showModal(this.errorModal);
            }
          }

          this.resetButtonState();
          this.clearEmailField();
          resolve();
        },
        error: (error) => {
          console.error("🚨 BŁĄD AJAX:", error);
          this.showModal(this.errorModal);
          this.errorMessage.removeClass('d-none');

          this.resetButtonState();
          reject(error);
        }
      });
    });
  }

  hideAllMessages() {
    this.successMessage.addClass('d-none');
    this.errorMessage.addClass('d-none');
    this.errorMessage1304.addClass('d-none');
  }

  resetButtonState() {
    console.log("🔄 Resetowanie przycisków po zakończeniu wysyłki.");
    this.buttonSend.removeClass('d-none');
    this.buttonSending.addClass('d-none');
    this.inputEmail.attr('readonly', false);
  }

  clearEmailField() {
    console.log("🧹 Czyszczenie pola e-mail.");
    this.inputEmail.val('');
  }

  bind() {
    this.form.validate({
      submitHandler: (form) => {
        let email = this.inputEmail.val();

        console.log("📩 Email z formularza przed sprawdzeniem:", email);
        console.log("📤 Dane formularza przed wysłaniem:", new FormData(form));

        this.buttonSend.addClass('d-none');
        this.buttonSending.removeClass('d-none');
        this.inputEmail.attr('readonly', true);

        this.send()
          .then(() => {
            console.log("✅ Proces zakończony. Przywracam formularz...");
            this.resetButtonState();
            this.clearEmailField();
          })
          .catch((error) => {
            console.log("⚠️ Błąd wysyłki – resetujemy przycisk.");
            this.resetButtonState();
            this.clearEmailField();
          });
      }
    });
  }

  showModal(modal) {
    if (!modal) return;
    modal.classList.add('show', 'd-block');
    modal.style.display = 'block';

    modal.addEventListener('click', (event) => {
      if (event.target.classList.contains('modal')) {
        this.hideModal(modal);
      }
    });

    let closeButton = modal.querySelector('[data-bs-dismiss="modal"]');
    if (closeButton) {
      closeButton.addEventListener('click', () => this.hideModal(modal));
    }
  }

  hideModal(modal) {
    if (!modal) return;
    modal.classList.remove('show', 'd-block');
    modal.style.display = 'none';
  }
}

// 🔥 **Inicjalizacja dla wszystkich formularzy na stronie**
jQuery(document).ready(() => {
  console.log("🚀 Inicjalizacja NewsletterMailerLite");
  
  jQuery('.newsletter-freshmail').each((index, elem) => {
    new NewsletterMailerLite(jQuery(elem));
  });

  // Ponowna inicjalizacja dla popupu po otwarciu
  jQuery(document).on('shown.bs.modal', '#newsletterPopupModal', function () {
    console.log("🔄 Modal otwarty – ponowna inicjalizacja NewsletterMailerLite");
  
    jQuery(this).find('.newsletter-freshmail').each((index, elem) => {
      console.log("📑 Znaleziono formularz w popupie:", elem);
      new NewsletterMailerLite(jQuery(elem));
    });
  });
  
});


